<!--
 * @Author: WangChao
 * @Date: 2026-04-21 12:01:32
 * @LastEditors: WangChao
 * @LastEditTime: 2026-09-07 12:18:34
 * @FilePath: \travel_ai\src\App.vue
 * @Description: 拓展发消息模块
-->
<template>
  <div id="app">
    <a-spin :spinning="loading" :tip="loadingTip" class="view-box">
      <keep-alive :include="keepAliceArray">
        <router-view class="router-view orderRou" />
      </keep-alive>
    </a-spin>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DsUtils from "yn-p1/libs/utils/DsUtils";
import UiUtils from "yn-p1/libs/utils/UiUtils";
import RouterUtils from "yn-p1/libs/utils/RouterUtils";
import { APPS, BACKEND } from "@/config/SETUP";
// const fun = require("@/lib/fun");
export default {
  name: "App",
  data() {
    return {
      historyStateArray: [],
      curHistoryStateIndex: 0, // 当前 state 在 history数组中的 下标
      prevHistoryLength: 0, //  前一次 history数组长度
    }
  },
  computed: {
    ...mapState("chat", ["flightKeepArray", "loading", "loadingTip"]),
    keepAliceArray() {
      let total = [];
      total = total.concat(this.flightKeepArray);
      return total;
    }
  },
  beforeCreate() {
    DsUtils.init(BACKEND.BASE_URL, APPS.NAME);
    UiUtils.init(this);
    RouterUtils.init(this);
  },
  mounted() {
    this.routerChange();
    // fun.freeStyleLog();
  },
  methods: {
    historyLength() {
      if (window.history.length > this.prevHistoryLength) {
        // 增加新的页面
        this.historyStateArray.push(history.state);
        this.curHistoryStateIndex = this.historyStateArray.length - 1;
      } else if (window.history.length < this.prevHistoryLength) {
        // 后退之后 跳转新的页面
        this.historyStateArray.splice(window.history.length - 1);
        this.historyStateArray.push(history.state);
        this.curHistoryStateIndex = this.historyStateArray.length - 1;
      } else {
        // 浏览器 前进或者后退
        this.historyStateArray.some((item, index) => {
          const { state } = history;
          if (history && state && item && item.key === state.key) {
            this.curHistoryStateIndex = index;
            return true;
          }
        });
      }
      this.prevHistoryLength = window.history.length;
      console.log("路由长度", this.curHistoryStateIndex);
      this.$pm.send({
        msgId: "routeChange_historyLength",
        data: {
          historyLength: this.curHistoryStateIndex
        }
      });
    },
    routerChange() {
      this.$router.afterEach((to, from) => {
        const { path } = to;
        if (path !== from.path) {
          this.$pm.send({
            msgId: "ivRouteChange",
            data: {
              path
            }
          });
          console.log("路由地址变化", from.path, "=>", to.path);
          this.historyLength();
        }
      });
    }
  }
};
</script>
<style lang="less">
#app {
  height: 100%;
}
.view-box {
  height: 100%;
  .ant-spin-text {
    font-size: 16px;
    padding-top: 30px !important;
  }
  .ant-spin-container {
    height: 100%;
  }
  router-view {
    height: 100%;
  }
}
</style>
